import { firstValueFrom } from 'rxjs';

import { ReferenceDataService } from '@aw/prypco/services/reference-data';
import { AuthFacade } from '@aw/prypco/state/auth';
import { FirebaseRemoteConfigService } from '../firebase/data-access/remote-config-firebase.service';

const initAuthState = (authFacade: AuthFacade) =>
  firstValueFrom(authFacade.initialize());

const initReferenceData = (referenceDataService: ReferenceDataService) =>
  firstValueFrom(referenceDataService.init());

export const appInitializer =
  (
    referenceDataService: ReferenceDataService,
    authFacade: AuthFacade,
    remoteConfigService: FirebaseRemoteConfigService,
  ) =>
  async () => {

    await Promise.allSettled([
      initReferenceData(referenceDataService),
      initAuthState(authFacade),
    ]);

    await remoteConfigService.loadConfig();
    const allConfig = remoteConfigService.getAllConfig();
    authFacade.setRemoteConfig(allConfig);
  };
